export default "__VITE_PUBLIC_ASSET__6a983a54__"